// src/hooks/auth/useAuthRedirect.js
import { useEffect } from "react";

export default function useAuthRedirect(user) {
  useEffect(() => {
    if (!user) {
      window.location.href = "/";
    }
  }, [user]);
}